import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChoosingRightDomainName } from './components/RightDomainName';
import { Header } from './components/Header';

function Post3() {
  return (
    <div className="App">
      <Header />
      <ChoosingRightDomainName />
    </div>
  );
}

export default Post3;